import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router';
import { fallbackUrl } from 'common/components/AppNavigation/utils/getUserConfirmation';
/**
 * This component handles page changes using
 *  - <Prompt /> react-router  component for history location changes
 *      (https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/Prompt.md)
 *  - 'beforeunload' native event for browser events (closing the browser or  a tab)
 *      (https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
 */
const PromptWithBrowser = React.memo((props) => {
    useEffect(() => {
        const handler = (e) => {
            if (props.when) {
                e.preventDefault();

                e.returnValue = props.message;
            }
        };
        fallbackUrl.setUrl(window.location.pathname);
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        window.addEventListener('beforeunload', handler);

        return () => {
            fallbackUrl.setUrl(null);
            window.removeEventListener('beforeunload', handler);
        };
    }, [props.when]);

    return <Prompt when={props.when} message={props.message} />;
});

PromptWithBrowser.propTypes = {
    when: PropTypes.bool,
    message: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
};

PromptWithBrowser.defaultProps = {
    when: false,
};

export default PromptWithBrowser;
